const D = "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj48cGF0aCBkPSJNMTMuMzAzIDIuNTg1bDkuNDc3IDkuNDc3LTEuNDEzIDEuNDEzTDE5Ljg5IDEydjhhMiAyIDAgMCAxLTIgMmgtMTJhMiAyIDAgMCAxLTItMnYtOC4wMDJsLTEuNDc3IDEuNDc3TDEgMTIuMDYybDkuNDc3LTkuNDc3Yy43OC0uNzggMi4wNDYtLjc4IDIuODI2IDB6TTExLjg5IDRsLTYuMDAyIDZoLjAwMnYxMGgxMlYxMGguMDAxTDExLjg5IDMuOTk5eiIgZmlsbC1ydWxlPSJldmVub2RkIi8+PC9zdmc+Cg==";
export {
  D as default
};
//# sourceMappingURL=home-35f8e1f6.mjs.map
